import { render, staticRenderFns } from "./ShippedDetail.vue?vue&type=template&id=0ee7f88e&scoped=true&"
import script from "./ShippedDetail.vue?vue&type=script&lang=js&"
export * from "./ShippedDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShippedDetail.vue?vue&type=style&index=0&id=0ee7f88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee7f88e",
  null
  
)

export default component.exports